/**
 * Verifies whether or not an object is empty by testing if it has any properties
 */
export const isEmptyObject = (obj: object) => Object.keys(obj).length === 0
